import React from 'react';
import { Modal } from 'components';
import ReactTooltip from 'react-tooltip';
import { IconInformation } from '../../img';

const ReviewModel = ({
  data,
  closeModal,
  handleStateChange,
  updateReview
}) => {
  return (
    <div>
      <Modal
        id='NotificationModal'
        className='appconnectmodal appgooglemodal'
        title=''
        content={
          <div className="modal-body ">
            <div className="modal-app-content">
              <form className="app-connect app-connect-google">

                <div className="nf-group-input mt-25">
                  <label>First Name</label>
                  <div className="tootltip seeting-tooltip">
                    <img data-tip data-for='fn' src={IconInformation} alt="" />
                    <ReactTooltip id='fn' aria-haspopup='true' role='example'>
                      <p>Enter first name</p>
                    </ReactTooltip>
                  </div>
                  <input type="text" name="fn" className="nf-input" id="" placeholder="First Name" value={data.fn} onChange={handleStateChange} />
                </div>

                <div className="nf-group-input mt-25">
                  <label>Last Name</label>
                  <div className="tootltip seeting-tooltip">
                    <img data-tip data-for='ac' src={IconInformation} alt="" />
                    <ReactTooltip id='ac' aria-haspopup='true' role='example'>
                      <p>Enter last name</p>
                    </ReactTooltip>
                  </div>
                  <input type="text" name="ln" className="nf-input" id="" placeholder="Last Name" value={data.ln} onChange={handleStateChange} />
                </div>

                <div className="nf-group-input mt-25">
                  <label>User Name</label>
                  <div className="tootltip seeting-tooltip">
                    <img data-tip data-for='ac' src={IconInformation} alt="" />
                    <ReactTooltip id='ac' aria-haspopup='true' role='example'>
                      <p>Enter username</p>
                    </ReactTooltip>
                  </div>
                  <input type="text" name="un" className="nf-input" id="" placeholder="User Name" value={data.un} onChange={handleStateChange} />
                </div>
                <div className="nf-group-input mt-25">
                  <label>Ratings</label>
                  <div className="tootltip seeting-tooltip">
                    <img data-tip data-for='rtng' src={IconInformation} alt="" />
                    <ReactTooltip id='rtng' aria-haspopup='true' role='example'>
                      <p>Enter Ratings</p>
                    </ReactTooltip>
                  </div>
                  <input type="text" name="rtng" className="nf-input" id="" placeholder="Ratings" value={data.rtng} onChange={handleStateChange} />
                </div>
                <div className="nf-group-input mt-25">
                  <label>Rating Text</label>
                  <div className="tootltip seeting-tooltip">
                    <img data-tip data-for='msg' src={IconInformation} alt="" />
                    <ReactTooltip id='msg' aria-haspopup='true' role='example'>
                      <p>Enter Rating Text</p>
                    </ReactTooltip>
                  </div>
                  <input type="text" name="msg" className="nf-input" id="" placeholder="Rating Text" value={data.msg} onChange={handleStateChange} />
                </div>
                <div className="nf-btn-login mt-10">
                  <button type='button' className="nf-btn  nf-btn-primary" onClick={() => updateReview(data._id)}>
                    Update
                  </button>
                </div>
              </form>
            </div>
          </div>
        }
        openCloseModal={() => closeModal()}
        style={
          {
            modalStyle: {
              display: data.ocReview ? 'block' : 'none',
              opacity: data.ocReview ? 1 : 0
            },
            alignModalStyle: {
              top: '210px'
            }
          }
        }
      />
    </div>
  );
};

export default ReviewModel;


// WEBPACK FOOTER //
// ./src/components/Review/ReviewModel.js